import React from "react";
import "tailwindcss/tailwind.css";
import "../../style/twform.css";
import { navigate } from "gatsby";

const EmptyState = ({
  icon,
  buttonTitle,
  description,
  openWidgetAction,
  tab,
  locale,
}) => {
  const handleClick = () => {
    if (tab === "voucher") {
      locale != "en"
        ? navigate(`/${locale}/reward?page=1`)
        : navigate(`/reward?page=1`);
    } else {
      openWidgetAction();
    }
  };
  return (
    <div
      className={`tw-flex tw-justify-between tw-items-center tw-flex-col tw-gap-6 tw-w-[335px] md:tw-w-[400px] tw-m-auto ${
        tab === "reservation"
          ? "tw-mt-24 md:tw-mt-16"
          : "tw-mt-[100px] md:tw-mt-18"
      }`}>
      <img
        src={icon}
        alt="calendar"
        style={{ width: "80px", height: "80px" }}
      />
      <div className="tw-leading-5 tw-font-normal">{description}</div>
      <button
        className="tw-bg-transparent tw-px-4 tw-py-2 tw-font-gotham tw-text-[14px] tw-leading-6 tw-text-center tw-text-[#37B0E5] tw-cursor-pointer"
        style={{ border: "2px solid #37B0E5" }}
        onClick={handleClick}>
        {buttonTitle}
      </button>
    </div>
  );
};

export default EmptyState;
